import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from '../hooks/useTranslation';
import { Download, Apple, PhoneAndroid } from '../mui-icons';
import './DownloadPage.css';

const DownloadPage = () => {
  const { t } = useTranslation();
  const [redirecting, setRedirecting] = useState(true);
  const [platform, setPlatform] = useState('detecting');

  // URLs das lojas
  const STORE_URLS = {
    ios: 'https://apps.apple.com/us/app/personalnutri/id6753727736',
    android: 'https://play.google.com/store/apps/details?id=com.personalnutri.app&pcampaignid=web_share'
  };

  useEffect(() => {
    // Detectar plataforma
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);

    let detectedPlatform = 'unknown';
    let redirectUrl = null;

    if (isIOS) {
      detectedPlatform = 'ios';
      redirectUrl = STORE_URLS.ios;
    } else if (isAndroid) {
      detectedPlatform = 'android';
      redirectUrl = STORE_URLS.android;
    }

    setPlatform(detectedPlatform);

    // Redirecionar após 2 segundos se detectou plataforma
    if (redirectUrl) {
      const timer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);

      return () => clearTimeout(timer);
    } else {
      // Se não detectou, parar de mostrar "redirecionando"
      setTimeout(() => {
        setRedirecting(false);
      }, 1500);
    }
  }, []);

  const handleManualDownload = (storeType) => {
    window.location.href = STORE_URLS[storeType];
  };

  return (
    <div className="download-page surface-marketing">
      <Header />

      {/* Header Verde */}
      <section className="download-header-section">
        <div className="container">
          <div className="download-header-content">
            <Download sx={{ fontSize: 60 }} />
            <h1 className="download-main-title">{t('download.hero.title')}</h1>
            <p className="download-main-subtitle">
              {t('download.hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      <div className="container download-container">
        {/* Redirecting Section */}
        {redirecting && platform !== 'unknown' ? (
          <section className="download-redirecting-card pn-card pn-card--auth">
            <div className="download-spinner">
              <Download className="spinner-icon" sx={{ fontSize: 80 }} />
            </div>
            <h2 className="download-redirecting-title">
              {platform === 'detecting' ? t('download.detecting') : t('download.redirecting')}
            </h2>
            <p className="download-redirecting-subtitle">
              {platform === 'ios' && 'App Store'}
              {platform === 'android' && 'Google Play'}
            </p>
          </section>
        ) : (
          /* Manual Selection */
          <section className="download-manual-section">
            <div className="download-info-card pn-card pn-card--default">
              <h2 className="download-info-title">{t('download.error.title')}</h2>
              <p className="download-info-description">
                {t('download.error.message')}
              </p>
            </div>

            <div className="download-buttons-grid">
              <button
                className="store-download-button ios-button"
                onClick={() => handleManualDownload('ios')}
              >
                <div className="store-button-icon">
                  <Apple sx={{ fontSize: 48 }} />
                </div>
                <div className="store-button-text">
                  <span className="store-button-label">{t('download.error.ios')}</span>
                  <span className="store-button-store">App Store</span>
                </div>
              </button>

              <button
                className="store-download-button android-button"
                onClick={() => handleManualDownload('android')}
              >
                <div className="store-button-icon">
                  <PhoneAndroid sx={{ fontSize: 48 }} />
                </div>
                <div className="store-button-text">
                  <span className="store-button-label">{t('download.error.android')}</span>
                  <span className="store-button-store">Google Play</span>
                </div>
              </button>
            </div>
          </section>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default DownloadPage;

